import React, { useContext } from 'react'

import { useSelector } from 'react-redux'

import TitledSelector from '../../../../Components/institution/Quotas/allocation/TitledSelector'
import InstitutionSchoolsList from './InstitutionSchoolsList'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { Properties } from '../../../../utils/entities'
import InstitutionSectionsList from './InstitutionSectionsList'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { getIdOrNull } from '../../../../utils'

const TITLED_SELECTOR_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginBottom: '10px'
}

const Settings = ({ coloredEntity, sectionToYears, schools, onSelectSectionToYear, onSelectSchool, onSelectSector }) => {
  const t = useSelector(selectTranslate)

  const { sectors } = useContext(InstitutionContext)

  return (
    <div className='pd-4 w-100'>
      <TitledSelector
        style={TITLED_SELECTOR_STYLE}
        data={sectors}
        dataKey='name'
        title={t('Care unit')}
        placeholder={t('Choose a care unit')}
        onDataSelected={onSelectSector}
      />
      <div style={{ height: 'calc(100% - 145px)', width: '300px' }}>
        {coloredEntity === Properties.SCHOOL && (
          <InstitutionSchoolsList selected={schools.map(getIdOrNull)} onSelect={onSelectSchool} />
        )}
        {coloredEntity === Properties.SECTION_TO_YEAR && (
          <InstitutionSectionsList selected={sectionToYears.map(getIdOrNull)} onSelect={onSelectSectionToYear} />
        )}
      </div>
    </div>
  )
}

export default Settings
